import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ProductIcon = ({ color })=>/*#__PURE__*/ _jsxs("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M16.8139 15.8139C16.8139 16.0567 16.7175 16.2895 16.5458 16.4611C16.3742 16.6327 16.1413 16.7292 15.8986 16.7292H4.91528C4.67253 16.7292 4.43972 16.6327 4.26808 16.4611C4.09643 16.2895 4 16.0567 4 15.8139V3.91528C4 3.67253 4.09643 3.43972 4.26808 3.26808C4.43972 3.09643 4.67253 3 4.91528 3H14.0955C14.3345 3.00003 14.564 3.09354 14.735 3.26055L16.5381 5.0191C16.6255 5.10442 16.6948 5.20635 16.7422 5.3189C16.7896 5.43144 16.814 5.55233 16.8139 5.67444V15.8139Z",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.8066 8.04395L14.0948 10.3321L11.8066 12.6203",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.06163 8.04395L6.77344 10.3321L9.06163 12.6203",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
